import { useEffect, useRef, useCallback } from 'react';

const IDLE_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'];
const IDLE_TIMEOUT_MS = 10 * 60 * 1000; // 10 minutes

/**
 * Logs the user out after IDLE_TIMEOUT_MS of inactivity.
 * Resets timer on any mouse/keyboard/touch/scroll event.
 */
export function useIdleTimeout(onTimeout) {
  const timerRef = useRef(null);

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      onTimeout();
    }, IDLE_TIMEOUT_MS);
  }, [onTimeout]);

  useEffect(() => {
    resetTimer();
    IDLE_EVENTS.forEach(evt => window.addEventListener(evt, resetTimer, { passive: true }));
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      IDLE_EVENTS.forEach(evt => window.removeEventListener(evt, resetTimer));
    };
  }, [resetTimer]);
}
